import services from '../services'

export async function fetchCards ({ commit }, params) {
  if (!params) params = {}
  commit('SET_LOADING', true)
  try {
    var response = await services.getCards(params)
    commit('SET_CARDS', response.data)
    return response.data
  } catch (error) {
    console.error('Error fetching cards:', error)
    throw error
  } finally {
    commit('SET_LOADING', false)
  }
}

export async function fetchCard ({ commit }, id) {
  commit('SET_LOADING', true)
  try {
    var response = await services.getCard(id)
    commit('SET_CARD', response.data)
    return response.data
  } catch (error) {
    console.error('Error fetching card:', error)
    throw error
  } finally {
    commit('SET_LOADING', false)
  }
}

export async function fetchGlobalCard ({ commit }) {
  commit('SET_LOADING', true)
  try {
    var response = await services.getGlobalCard()
    commit('SET_CARD', response.data)
    return response.data
  } catch (error) {
    console.error('Error fetching global card:', error)
    throw error
  } finally {
    commit('SET_LOADING', false)
  }
}

export async function fetchAvailableFields ({ commit }) {
  try {
    var response = await services.getAvailableFields()
    commit('SET_AVAILABLE_FIELDS', response.data)
    return response.data
  } catch (error) {
    console.error('Error fetching available fields:', error)
    throw error
  }
}

export async function createCard ({ commit }, data) {
  try {
    var response = await services.createCard(data)
    return response.data
  } catch (error) {
    console.error('Error creating card:', error)
    throw error
  }
}

export async function updateCard ({ commit, state }, data) {
  try {
    var response = await services.updateCard(state.card.id, data)
    // Backend agora retorna as tabs completas com fields
    commit('SET_CARD', response.data)
    commit('SET_DIRTY', false)
    return response.data
  } catch (error) {
    console.error('Error updating card:', error)
    throw error
  }
}

export async function duplicateCard ({ dispatch }, id) {
  try {
    var response = await services.duplicateCard(id)
    await dispatch('fetchCards')
    return response.data
  } catch (error) {
    console.error('Error duplicating card:', error)
    throw error
  }
}

export async function deleteCard ({ dispatch }, id) {
  try {
    await services.deleteCard(id)
    await dispatch('fetchCards')
  } catch (error) {
    console.error('Error deleting card:', error)
    throw error
  }
}

export async function createTab ({ commit, state }, data) {
  try {
    var response = await services.createTab(state.card.id, data)
    commit('ADD_TAB', response.data)
    commit('SET_DIRTY', true)
    return response.data
  } catch (error) {
    console.error('Error creating tab:', error)
    throw error
  }
}

export async function updateTab ({ commit, state }, payload) {
  var tabId = payload.tabId
  var data = payload.data
  try {
    var response = await services.updateTab(state.card.id, tabId, data)
    commit('UPDATE_TAB', { tabId: tabId, data: response.data })
    commit('SET_DIRTY', true)
    return response.data
  } catch (error) {
    console.error('Error updating tab:', error)
    throw error
  }
}

export async function deleteTab ({ commit, state }, tabId) {
  try {
    await services.deleteTab(state.card.id, tabId)
    commit('REMOVE_TAB', tabId)
    commit('SET_DIRTY', true)
  } catch (error) {
    console.error('Error deleting tab:', error)
    throw error
  }
}

export async function reorderTabs ({ commit, state }, tabs) {
  try {
    var response = await services.reorderTabs(state.card.id, tabs)
    // Backend agora retorna as tabs completas com os campos
    commit('REORDER_TABS', response.data)
    commit('SET_DIRTY', true)
  } catch (error) {
    console.error('Error reordering tabs:', error)
    throw error
  }
}

export async function createField ({ commit, state }, payload) {
  var tabId = payload.tabId
  var data = payload.data
  try {
    var response = await services.createField(state.card.id, tabId, data)
    commit('ADD_FIELD', { tabId: tabId, field: response.data })
    commit('SET_DIRTY', true)
    return response.data
  } catch (error) {
    console.error('Error creating field:', error)
    throw error
  }
}

export async function updateField ({ commit, state }, payload) {
  var tabId = payload.tabId
  var fieldId = payload.fieldId
  var data = payload.data
  try {
    var response = await services.updateField(state.card.id, tabId, fieldId, data)
    commit('UPDATE_FIELD', { tabId: tabId, fieldId: fieldId, data: response.data })
    commit('SET_DIRTY', true)
    return response.data
  } catch (error) {
    console.error('Error updating field:', error)
    throw error
  }
}

export async function deleteField ({ commit, state }, payload) {
  var tabId = payload.tabId
  var fieldId = payload.fieldId
  try {
    await services.deleteField(state.card.id, tabId, fieldId)
    commit('REMOVE_FIELD', { tabId: tabId, fieldId: fieldId })
    commit('SET_DIRTY', true)
  } catch (error) {
    console.error('Error deleting field:', error)
    throw error
  }
}

export async function reorderFields ({ commit, state }, payload) {
  var tabId = payload.tabId
  var fields = payload.fields
  // Mapear para {id, order} com índice correto baseado na posição do array
  var mappedFields = fields.map(function (f, index) {
    return { id: f.id, order: index }
  })
  try {
    await services.reorderFields(state.card.id, tabId, mappedFields)
    // Atualizar order local nos fields antes de commitar
    var updatedFields = fields.map(function (f, index) {
      var copy = Object.assign({}, f)
      copy.order = index
      return copy
    })
    commit('REORDER_FIELDS', { tabId: tabId, fields: updatedFields })
    commit('SET_DIRTY', true)
  } catch (error) {
    console.error('Error reordering fields:', error)
    throw error
  }
}

export async function moveField ({ commit, state }, payload) {
  var tabId = payload.tabId
  var fieldId = payload.fieldId
  var newTabId = payload.newTabId
  var order = payload.order
  try {
    await services.moveField(state.card.id, tabId, fieldId, { new_tab_id: newTabId, order: order })
    commit('REMOVE_FIELD', { tabId: tabId, fieldId: fieldId })
    commit('SET_DIRTY', true)
    await fetchCard({ commit: commit }, state.card.id)
  } catch (error) {
    console.error('Error moving field:', error)
    throw error
  }
}

export async function autoOrganize ({ commit, state }, data) {
  try {
    var response = await services.autoOrganize(state.card.id, data)
    commit('SET_CARD', response.data)
    return response.data
  } catch (error) {
    console.error('Error auto-organizing card:', error)
    throw error
  }
}

export function selectTab ({ commit }, tab) {
  commit('SET_SELECTED_TAB', tab)
}

export function selectField ({ commit }, field) {
  commit('SET_SELECTED_FIELD', field)
}

export function setPreviewGroup ({ commit }, groupId) {
  commit('SET_PREVIEW_GROUP_ID', groupId)
}

export function markDirty ({ commit }) {
  commit('SET_DIRTY', true)
}

export function resetBuilder ({ commit }) {
  commit('RESET_BUILDER')
}
